import * as tslib_1 from "tslib";
import { NgbDateAdapter } from '@ng-bootstrap/ng-bootstrap';
import * as moment from 'moment';
var isInt = Number.isInteger;
var NgbDateMomentAdapter = /** @class */ (function (_super) {
    tslib_1.__extends(NgbDateMomentAdapter, _super);
    function NgbDateMomentAdapter() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    NgbDateMomentAdapter.prototype.fromModel = function (date) {
        if (!date || !moment.isMoment(date)) {
            return null;
        }
        return {
            year: date.year(),
            month: date.month() + 1,
            day: date.date(),
        };
    };
    NgbDateMomentAdapter.prototype.toModel = function (date) {
        if (!date || !isInt(date.day) || !isInt(date.day) || !isInt(date.day)) {
            return null;
        }
        return moment(date.year + "-" + date.month + "-" + date.day, 'YYYY-MM-DD');
    };
    return NgbDateMomentAdapter;
}(NgbDateAdapter));
export { NgbDateMomentAdapter };
